import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { Login2Component } from './login2/login2.component';
import { DeviceListComponent } from './device-list/device-list.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { DeviceDetailsComponent } from './device-details/device-details.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { ConfigurationListComponent } from './ota/configuration-list/configuration-list.component';
import { UploadComponent } from './ota/upload/upload.component';
import { ConfigurationHistoryComponent } from './ota/configuration-history/configuration-history.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { GroupManagementComponent } from './user-management/group-management/group-management.component';
import { GroupAssignmentManagementComponent } from './user-management/group-assignment-management/group-assignment-management.component';
import { RolePermissionManagementComponent } from './user-management/role-permission-management/role-permission-management.component';
import { UserListComponent } from './user-management/user-list/user-list.component';
// Teal Integration routes are lazy-loaded


export const routes: Routes = [
  { 
    path: 'login', 
    component: LoginComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'login2',
    component: Login2Component,
    canActivate: [LoginGuard],
  },
  { 
    path: 'forgot-password', 
    component: ForgotPasswordComponent 
  },
  { 
    path: 'device-list', 
    component: DeviceListComponent,
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  { 
    path: 'onboarding', 
    component: OnboardingComponent,
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  { 
    path: 'ota/device-configuration-list', 
    component: ConfigurationListComponent,
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  { 
    path: 'ota/device-configuration-history', 
    component: ConfigurationHistoryComponent,
    canActivate: [AuthGuard]
  },
  { 

    path: 'device-details/:id',
    component: DeviceDetailsComponent,
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'ota/device-configuration-upload', 
    component: UploadComponent,
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'customer-list',
    redirectTo: '/user-management/customers',
    pathMatch: 'full'
  },
  {
    path: 'user-management/customers',
    component: CustomerListComponent,
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'user-management/group-management',
    component: GroupManagementComponent,
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'user-management/user-list',
    component: UserListComponent,
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'user-management/customer-group-management',
    component: GroupAssignmentManagementComponent,
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'user-management/group-assignment-management',
    redirectTo: 'user-management/customer-group-management',
    pathMatch: 'full',
  },
  {
    path: 'user-management/role-permission-management',
    component: RolePermissionManagementComponent,
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  { 
    path: 'device-details',
    component: DeviceDetailsComponent,
    canActivate: [AuthGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  { 
    path: 'teal-integration/esim-info',
    loadComponent: () => import('./teal-integration/esim-info/esim-info.component').then(m => m.EsimInfoComponent),
    canActivate: [AuthGuard]
  },
  { 
    path: 'teal-integration/api-log',
    loadComponent: () => import('./teal-integration/teal-api-log/teal-api-log.component').then(m => m.TealApiLogComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'teal-integration/operation-results',
    loadComponent: () => import('./teal-integration/operation-results/operation-results.component').then(m => m.OperationResultsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: '',
    redirectTo: '/device-list',
    pathMatch: 'full'
  },
  { 
    path: '**', 
    redirectTo: '/device-list' 
  }
];
